<template>
  <div>
    <div style="position: sticky; top: 0; z-index: 10; background: #fff; padding: 5px 0;">
      <el-button type="primary" icon="el-icon-upload2" :loading="importing" :disabled="validRows.length===0" @click="doImport">确定导入</el-button>
      <el-button type="success" icon="el-icon-folder-add" @click="openFileDialog">重新选择文件</el-button>
      <el-checkbox v-if="parsed" v-model="skipNameCheck" style="margin-left: 10px">不检查医疗机构名称</el-checkbox>
      <span v-if="parsed" style="margin-left: 10px; color: #333">
        共解析 {{totalRows}} 条，合法 {{validRows.length}} 条
        <span v-if="codeNotFoundCount>0" style="color:#F56C6C">，编号不存在 {{codeNotFoundCount}} 条</span>
        <span v-if="nameErrorCount>0" style="color:#F56C6C">，名称错误 {{nameErrorCount}} 条</span>
        <span v-if="dataEmptyCount>0" style="color:#F56C6C">，数据为空 {{dataEmptyCount}} 条</span>
        <span v-if="formatCount>0" style="color:#F56C6C">，格式错误 {{formatCount}} 条</span>
      </span>
    </div>

    <el-tabs v-model="activeName" type="card" v-if="tabs.length>0" style="margin-top: 10px">
      <el-tab-pane
        v-if="errorList.length>0"
        name="__error__"
        :label="'错误数据（'+errorList.length+'）'">
        <el-table
          :data="errorList"
          border
          style="width: 100%"
          max-height="100%"
          :row-class-name="rowClass">
          <el-table-column
            prop="sheet"
            label="所属页签"
            width="160">
          </el-table-column>
          <el-table-column
            prop="serial"
            label="序号"
            width="90">
          </el-table-column>
          <el-table-column
            prop="name"
            label="医疗机构名称"
            width="260">
          </el-table-column>
          <el-table-column
            prop="hospital_code"
            label="编号"
            width="120">
          </el-table-column>
          <el-table-column
            prop="amount"
            label="合同预付金额（元）"
            width="160">
          </el-table-column>
          <el-table-column
            prop="date"
            label="到账日期"
            width="130">
          </el-table-column>
          <el-table-column
            prop="error"
            label="状态"
            min-width="200">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        v-for="(tab,index) in tabs"
        :key="tab.name"
        :label="tab.name+'（'+tab.validCount+'/'+tab.list.length+'）'"
        :name="tab.name">
        <el-table
          :data="tab.list"
          border
          style="width: 100%"
          max-height="100%"
          :row-class-name="rowClass">
          <el-table-column
            prop="serial"
            label="序号"
            width="90">
          </el-table-column>
          <el-table-column
            prop="name"
            label="医疗机构名称"
            width="260">
          </el-table-column>
          <el-table-column
            prop="hospital_code"
            label="编号"
            width="120">
          </el-table-column>
          <el-table-column
            prop="amount"
            label="合同预付金额（元）"
            width="160">
          </el-table-column>
          <el-table-column
            prop="date"
            label="到账日期"
            width="130">
          </el-table-column>
          <el-table-column
            prop="error"
            label="状态"
            min-width="200">
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="批量导入充值" :visible.sync="importDialogVisible" width="500px" :close-on-click-modal="false">
      <input ref="fileInput" type="file" accept=".xlsx,.xls" style="width: 100%" @change="onFileSelect" />
      <div style="color:#909399;font-size:12px;margin-top:8px">请选择Excel文件，多页签sheet，第二行为列名，数据从第三行开始；列名顺序：序号、医疗机构名称、编号、合同预付金额（元）、到账日期</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible=false">取 消</el-button>
        <el-button type="primary" :disabled="!selectedFile" :loading="loading" @click="parseExcel">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import coder from "./enum.js"
import * as XLSX from "xlsx"
export default {
  methods: {
    pad(n){
      return n<10?'0'+n:''+n;
    },
    cellToStr(c){
      if (c===null||c===undefined||c==='') return '';
      if (c instanceof Date){
        return c.getFullYear()+'-'+this.pad(c.getMonth()+1)+'-'+this.pad(c.getDate());
      }
      return String(c).trim();
    },
    normalizeDate(s){
      if (s==='') return null;
      let m=/^(\d{4})[-./](\d{1,2})[-./](\d{1,2})$/.exec(s);
      if(!m) return null;
      let y=parseInt(m[1]),mo=parseInt(m[2]),day=parseInt(m[3]);
      if(mo<1||mo>12||day<1||day>31) return null;
      return y+'-'+this.pad(mo)+'-'+this.pad(day);
    },
    yuanToCents(s){
      let num=parseFloat(String(s).replace(/,/g,''));
      return Math.round(num*100);
    },
    normName(s){
      let str=String(s).toLowerCase();
      let out='';
      for(let i=0;i<str.length;i++){
        let code=str.charCodeAt(i);
        if (code>=0xFF01&&code<=0xFF5E){
          out+=String.fromCharCode(code-0xFEE0);
        }else if (code===0x3000){
          out+=' ';
        }else{
          out+=str[i];
        }
      }
      return out.replace(/\s+/g,'').replace(/[()]/g,'');
    },
    buildDict(list){
      let map={};
      for(let i=0;i<list.length;i++){
        let parts=String(list[i].value).split(' ');
        if (parts.length>=2){
          map[parts[0]]=parts.slice(1).join(' ').trim();
        }
      }
      return map;
    },
    validateRow(item){
      if (item.hospital_code==='') { item.category='dataEmpty'; return '编号不能为空'; }
      if (!/^\d+-\d+$/.test(item.hospital_code)) { item.category='format'; return '编号格式不正确（应为1-0001）'; }
      if (this.hospitalMap!==null&&this.hospitalMap!==undefined&&Object.keys(this.hospitalMap).length>0){
        let dictName=this.hospitalMap[item.hospital_code];
        if (dictName===undefined) { item.category='codeNotFound'; return '编号【'+item.hospital_code+'】不存在'; }
        item.correct_name=dictName;
        if (!this.skipNameCheck&&(item.name===''||this.normName(item.name)!==this.normName(dictName))) { item.category='nameError'; return '编号与医院名称不匹配（正确名称：'+dictName+'）'; }
      }
      if (item.amount===''||parseFloat(item.amount.replace(/,/g,''))<=0||isNaN(parseFloat(item.amount.replace(/,/g,'')))) { item.category='dataEmpty'; return '金额不能为0'; }
      if (item.date==='') { item.category='dataEmpty'; return '到账日期不能为空'; }
      if (this.normalizeDate(item.date)===null) { item.category='format'; return '日期格式不正确（应为2025-01-02或2025.1.2）'; }
      item.category='';
      return '';
    },
    onFileSelect(e){
      let f=e.target.files[0];
      this.selectedFile=f||null;
    },
    openFileDialog(){
      this.selectedFile=null;
      this.$nextTick(()=>{
        if (this.$refs.fileInput) this.$refs.fileInput.value='';
      });
      this.importDialogVisible=true;
    },
    parseExcel(){
      if (this.selectedFile===null||this.selectedFile===undefined){ return }
      if (Object.keys(this.hospitalMap).length===0){
        this.$alert('医院数据未加载，请稍后重试','错误',{confirmButtonText:'确定'});
        return
      }
      this.loading=true;
      let $this=this;
      let reader=new FileReader();
      reader.onload=function(e){
        try{
          let wb=XLSX.read(new Uint8Array(e.target.result),{type:'array',cellDates:true});
          $this.buildData(wb);
          $this.loading=false;
        }catch(err){
          $this.loading=false;
          $this.$alert('解析Excel失败：'+err.message,'错误',{confirmButtonText:'确定'});
        }
      };
      reader.readAsArrayBuffer(this.selectedFile);
    },
    buildData(wb){
      let tabs=[];
      let validRows=[];
      let totalRows=0;
      let invalidRows=[];
      let blankRows=0;
      let codeNotFoundCount=0;
      let nameErrorCount=0;
      let dataEmptyCount=0;
      let formatCount=0;
      for(let s=0;s<wb.SheetNames.length;s++){
        let name=wb.SheetNames[s];
        let ws=wb.Sheets[name];
        if(!ws) continue;
        let rows=XLSX.utils.sheet_to_json(ws,{header:1,raw:true,defval:''});
        let headers=(rows[1]||[]).map((h)=>this.cellToStr(h));
        let codeIdx=headers.findIndex((h)=>h.indexOf('编号')>=0);
        let amountIdx=headers.findIndex((h)=>h.indexOf('金额')>=0);
        let dateIdx=headers.findIndex((h)=>h.indexOf('日期')>=0);
        let nameIdx=headers.findIndex((h)=>h.indexOf('名称')>=0);
        if (codeIdx<0||amountIdx<0||dateIdx<0){
          this.$alert('页签['+name+']未找到列名（需包含“编号”、“金额”、“日期”），请检查Excel文件','错误',{confirmButtonText:'确定'});
          return;
        }
        let list=[];
        let validCount=0;
        let lastIdx=2;
        for(let i=2;i<rows.length;i++){
          let r=rows[i]||[];
          let isEmpty=r.every((c)=>c===''||c===null||c===undefined);
          if (!isEmpty) lastIdx=i;
        }
        for(let i=2;i<=lastIdx;i++){
          let r=rows[i]||[];
          let serial=this.cellToStr(r[0]);
          let item={
            sheet:name,
            serial:serial,
            name:nameIdx>=0?this.cellToStr(r[nameIdx]):'',
            hospital_code:this.cellToStr(r[codeIdx]),
            amount:this.cellToStr(r[amountIdx]),
            date:this.cellToStr(r[dateIdx]),
            error:'',
            valid:false,
            category:'',
          };
          let isEmpty=r.every((c)=>c===''||c===null||c===undefined);
          if (isEmpty){ blankRows++; totalRows++; continue; }
          item.error=this.validateRow(item);
          if (item.error===''){
            item.error='合法';
            item.valid=true;
            validCount++;
            validRows.push({
              hospital_code:item.hospital_code,
              amount:this.yuanToCents(item.amount),
              date:this.normalizeDate(item.date),
            });
          }else{
            item.valid=false;
            invalidRows.push(item);
            if (item.category==='codeNotFound') codeNotFoundCount++;
            else if (item.category==='nameError') nameErrorCount++;
            else if (item.category==='dataEmpty') dataEmptyCount++;
            else if (item.category==='format') formatCount++;
          }
          list.push(item);
          totalRows++;
        }
        tabs.push({name:name,list:list,validCount:validCount});
      }
      this.tabs=tabs;
      if (tabs.length>0){
        if (invalidRows.length>0){
          this.activeName='__error__';
        }else{
          this.activeName=tabs[0].name;
        }
      }else{
        this.activeName='';
      }
      this.validRows=validRows;
      this.totalRows=totalRows;
      this.parsed=true;
      this.errorList=invalidRows;
      this.blankRows=blankRows;
      this.codeNotFoundCount=codeNotFoundCount;
      this.nameErrorCount=nameErrorCount;
      this.dataEmptyCount=dataEmptyCount;
      this.formatCount=formatCount;
      this.importDialogVisible=false;
      if (invalidRows.length>0){
        this.$alert('存在 '+invalidRows.length+' 条不符合要求的数据（红色行），将不会被导入','提示',{confirmButtonText:'确定'});
      }
    },
    rowClass({row}){
      if (row.valid===false){
        return 'invalid-row';
      }
      return '';
    },
    doImport(){
      if (this.validRows.length===0){ return }
      let $this=this;
      let invalidCount=this.totalRows-this.validRows.length;
      let proceed=function(){
        if ($this.importing){ return }
        $this.importing=true;
        window.ws.AddFunc("S2W_ImportDepositRes",function (code,msg) {
          $this.importing=false;
          if (code===coder.OK){
            $this.$notify({
              title:'成功',
              message:msg||'导入成功',
              type:'success'
            });
            $this.tabs=[];
            $this.validRows=[];
            $this.errorList=[];
            $this.totalRows=0;
            $this.parsed=false;
          }else{
            $this.$alert(msg+'('+code+')','错误',{confirmButtonText:'确定'});
          }
        });
        window.ws.Call("W2S_ImportDeposit", $this.validRows);
      };
      if (invalidCount>0){
        this.$confirm('有 '+invalidCount+' 条数据不合法，将不会导入，仅导入 '+this.validRows.length+' 条合法数据，是否继续？','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
        }).then(proceed).catch(()=>{});
      }else{
        proceed();
      }
    },
    revalidate(){
      let validRows=[];
      let codeNotFoundCount=0;
      let nameErrorCount=0;
      let dataEmptyCount=0;
      let formatCount=0;
      let errorList=[];
      for(let t=0;t<this.tabs.length;t++){
        let tab=this.tabs[t];
        let validCount=0;
        for(let j=0;j<tab.list.length;j++){
          let item=tab.list[j];
          item.error=this.validateRow(item);
          if (item.error===''){
            item.error='合法';
            item.valid=true;
            validCount++;
            validRows.push({
              hospital_code:item.hospital_code,
              amount:this.yuanToCents(item.amount),
              date:this.normalizeDate(item.date),
            });
          }else{
            item.valid=false;
            errorList.push(item);
            if (item.category==='codeNotFound') codeNotFoundCount++;
            else if (item.category==='nameError') nameErrorCount++;
            else if (item.category==='dataEmpty') dataEmptyCount++;
            else if (item.category==='format') formatCount++;
          }
        }
        tab.validCount=validCount;
      }
      this.validRows=validRows;
      this.errorList=errorList;
      this.codeNotFoundCount=codeNotFoundCount;
      this.nameErrorCount=nameErrorCount;
      this.dataEmptyCount=dataEmptyCount;
      this.formatCount=formatCount;
    }
  },
  watch: {
    skipNameCheck(){
      this.revalidate();
    }
  },
  data() {
    return {
      importDialogVisible:false,
      selectedFile:null,
      loading:false,
      importing:false,
      parsed:false,
      tabs:[],
      activeName:'',
      totalRows:0,
      validRows:[],
      hospitals:[],
      hospitalMap:{},
      skipNameCheck:false,
      blankRows:0,
      errorList:[],
      codeNotFoundCount:0,
      nameErrorCount:0,
      dataEmptyCount:0,
      formatCount:0,
    }
  },
  mounted() {
    let $this=this;
    if (window.hospitals===undefined||window.hospitals===null||window.hospitals.length===0){
      window.ws.AddFunc("S2W_GetHospitalNamesRes",function(list){
        let names = [];
        for(let i=0;i<list.length;i++){
          names.push({value:list[i],label:list[i]})
        }
        window.hospitals=names;
        $this.hospitals=names;
        $this.hospitalMap=$this.buildDict(names);
      });
      window.ws.Call("W2S_GetHospitalNames");
    }else{
      this.hospitals=window.hospitals;
      this.hospitalMap=this.buildDict(window.hospitals);
    }
  }
}
</script>

<style scoped>
  >>> .invalid-row {
    color: #F56C6C;
  }
</style>


// WEBPACK FOOTER //
// src/view/BatchImportDeposit.vue